module.exports = __webpack_public_path__ + "img/6_1.57c40277.png";